import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { StyledHeadWrapper, StyledMenuWrapper } from './style';

const TrensferHead = () => {
  const location = useLocation();
  const { companyId } = useParams();
  const [selected, setSelected] = useState<boolean | null>(null);

  useEffect(() => {
    setSelected(location.pathname.includes('receiving'));
  }, [location.pathname, selected]);

  return (
    <StyledHeadWrapper>
      <strong>Transfer({location.state})</strong>
      <StyledMenuWrapper>
        <div className={selected ? '' : 'selected'}>
          <Link to={`/transfer/sending/${companyId}`} className={'go_license'}>
            Sending
          </Link>
        </div>
        <div className={selected ? 'selected' : ''}>
          <Link to={`/transfer/receiving/${companyId}`} className={'go_license'}>
            Receiving
          </Link>
        </div>
      </StyledMenuWrapper>
    </StyledHeadWrapper>
  );
};

export default TrensferHead;
